// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"HF-z","smallCardRow":"IF-z","largeCardRow":"JF-z","productSearchRow":"KF-z","curatedRow":"LF-z"};